var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "step-2-part-1" } }, [
      _c("div", { staticClass: "row mb-5" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("list-user-groups", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: _vm.userGroupsState.list.length > 1 },
                  expression: "{ required: userGroupsState.list.length > 1 }"
                }
              ],
              ref: "creatorGroup",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                "only-groups": "",
                label: "Grupo al que irá asociado el expediente (*)",
                name: "creatorGroup",
                danger: _vm.errors.has("step-2-part-1.creatorGroup"),
                "danger-text": _vm.errors.first("step-2-part-1.creatorGroup")
              },
              model: {
                value: _vm.step.creatorGroup,
                callback: function($$v) {
                  _vm.$set(_vm.step, "creatorGroup", $$v)
                },
                expression: "step.creatorGroup"
              }
            })
          ],
          1
        )
      ]),
      _vm._m(1),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Cargo Persona (*)",
                maxlength: "150",
                name: "personPosition",
                "data-vv-as": "cargo persona",
                danger: _vm.errors.has("step-2-part-1.personPosition"),
                "danger-text": _vm.errors.first("step-2-part-1.personPosition")
              },
              model: {
                value: _vm.step.personPosition,
                callback: function($$v) {
                  _vm.$set(_vm.step, "personPosition", $$v)
                },
                expression: "step.personPosition"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-2-part-2" } },
      [
        _vm._m(2),
        _c("SelectSubject", {
          attrs: { docTypeSelected: _vm.documentTypeSelected },
          on: {
            "add-subject": _vm.addSubject,
            "clear-sanitaries": _vm.clearSanitaries,
            "clear-doc-digital": _vm.clearDocDigital
          }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("TableSubjects", {
                attrs: { subjects: _vm.step.subjects },
                on: { "clear-doc-digital": _vm.clearDocDigital },
                model: {
                  value: _vm.step.subjectsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "subjectsSelected", $$v)
                  },
                  expression: "step.subjectsSelected"
                }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Datos de la persona que ingresa el documento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Origen / Datos Remitente")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Destinatario (*)")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }